import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ORDER_DETAILS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { OrderDetailsBlockScenarioContent } from '@front-platform/content-builder';
import { DoodOrderModel } from '@store/order/order.model';

import {
  ORDER_DETAILS_BLOCK_LOADING_VM,
  OrderDetailsBlockDataSource,
  OrderDetailsBlockViewModel,
} from './order-details-block-view-model';

@Injectable()
export class OrderDetailsBlockPreviewDataSource implements OrderDetailsBlockDataSource {
  readonly vm$: Observable<OrderDetailsBlockViewModel> = previewScenarioForBloc$(
    ORDER_DETAILS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return ORDER_DETAILS_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<OrderDetailsBlockScenarioContent>(
        scenario,
        ORDER_DETAILS_BLOCK_COMPONENT,
      );
      if (!content) {
        return ORDER_DETAILS_BLOCK_LOADING_VM;
      }

      return {
        order: (content.order as unknown as DoodOrderModel | null) ?? null,
        onSiteLocationName: content.onSiteLocationName,
      };
    }),
  );
}
